import { IEProduct } from "api/interfaces/product-api.type";
import { IOrderedItemView } from "interfaces/session/ShoppingCart";
import PASentry from "util/pa-sentry";
import { getCentAmount } from "../../util/helper/getCentAmount";
import { parseDollarAmt } from "../../util/helper/parseDollarAmt";
import { getProductHeading } from "../../util/product/get-product-heading";
import { isKit } from "../../util/product/is-kit";

interface IFbPixelPayload {
  content_ids: string[],
  content_name?: string,
  content_category?: string,
  content_type?: string,
  contents: {id: string, quantity: number}[],
  currency: string,
  num_items?: number,
  value: number | string,
  orderId?: string,
}

type IKeys = "content_ids" | "content_name" | "content_category" | "content_type" | "contents" | "currency" | "num_items" | "value" | "orderId";

const productKeysToFBPixelKeys: any = {
  content_ids: "sku",
};

export const FACEBOOK_PIXEL_EVENT_NAME = {
  ADD_TO_CART: "AddToCart",
  INITIATE_CHECKOUT: "InitiateCheckout",
  PURCHASE: "Purchase",
  VIEW_CONTENT: "ViewContent",
};

export function getFacebookPixelPayload(keys: IKeys[], product?:IEProduct, products?: IOrderedItemView[], totalPrice?: number, orderId?: string) {
  const payload: IFbPixelPayload = {};
  const { sku, quantity = 1, price } = product || {};

  keys.forEach((eachKey: IKeys) => {
    if (eachKey in productKeysToFBPixelKeys) {
      const key = productKeysToFBPixelKeys[eachKey];
      if (!product) {
        payload[eachKey] = products.map((eachItem) => eachItem[key]);
      } else {
        payload[eachKey] = [].concat(product[key]);
      }
    } else if (eachKey === "content_name") {
      payload.content_name = getProductHeading(product);
    } else if (eachKey === "content_type") {
      payload.content_type = isKit(product) ? "product_group" : "product";
    } else if (eachKey === "contents") {
      if (!product) {
        payload.contents = products.map((eachItem) => ({ id: eachItem.sku, quantity: eachItem.quantity, content_name: getProductHeading(eachItem) }));
      } else {
        payload.contents = [{ id: sku, quantity, content_name: getProductHeading(product) }];
      }
    } else if (eachKey === "currency") {
      payload.currency = "CAD";
    } else if (eachKey === "value") {
      payload.value = `${parseDollarAmt(price || totalPrice) }.${ getCentAmount(price || totalPrice)}`;
    } else if (eachKey === "num_items") {
      payload.num_items = products?.length;
    } else if (eachKey === "content_category") {
      const {
        tier0, tier1, tier2, tier3,
      } = product?.category || {};
      payload.content_category = tier3 || tier2 || tier1 || tier0;
    } else if (eachKey === "orderId") {
      payload.orderId = orderId;
    }
  });
  return payload;
}

export const fbPixelTrack = (eventName: string, keys: IKeys[], product?:any, products?: IOrderedItemView[], totalPrice?: number, orderId?: string) => {
  let payload = {};
  if (!product) {
    payload = getFacebookPixelPayload(keys, undefined, products, totalPrice, orderId);
  } else {
    payload = getFacebookPixelPayload(keys, product);
  }
  try {
    if (window.fbq) {
      window.fbq("track", eventName, payload);
    } else {
      const intervel = setInterval(() => {
        if (window.fbq) {
          clearInterval(intervel);
          window.fbq("track", eventName, payload);
        }
      }, 500);
    }
  } catch (err) {
    PASentry.logException(err, null, { eventName, payload });
  }
};
